import React, { Component } from 'react'
import Aux from '../../../../../hoc/Auxiliary/Auxiliary'

import {
  // Paper,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead
  // TableContainer
} from '@material-ui/core/'
import { getCurrencyNumber } from '../../../../../helpers/utils'
// import { ScrollSync, ScrollSyncPane } from 'react-scroll-sync'
// import { Scrollbars } from 'react-custom-scrollbars'

import { ResponsiveBullet } from '@nivo/bullet'
import { withStyles } from '@material-ui/core/styles'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import Grid from '@material-ui/core/Grid'

class Form extends Component {
  //   render() {
  //     let data1,
  //       data2,
  //       label_list,
  //       ranges,
  //       colors = []

  //     if (this.props.allData) {
  //       data1 = this.props.allData?.table?.map(item => {
  //         return item[0] ? item[0] : {}
  //       })
  //     }

  //     if (this.props.allData) {
  //       if (this.props.allData.table) {
  //         data2 = [...this.props.allData?.table]

  //         // find end_value
  //         ranges = (this.props.allData?.table[0]?.[0]?.threshold || []).map(thres => {
  //           // let itemRanges = (item[0]?.threshold || []).map(thres => thres.end_value)
  //           // let itemColors = (item[0]?.threshold || []).map(thres => thres.color_code)
  //           return thres.end_value
  //         })

  //         // find color_code
  //         colors = (this.props.allData?.table[0]?.[0]?.threshold || []).map(thres => {
  //           return thres.color_code
  //         })
  //       }
  //       if (this.props.allData.label_list) {
  //         label_list = [...this.props.allData?.label_list]
  //       }
  //     }

  //     return (
  //       <Paper style={{ overflow: 'visible' }}>
  //         <ScrollSync horizontal={false}>
  //           <TableContainer
  //             style={{
  //               display: 'grid',
  //               gridTemplateColumns: '4fr 1.6fr',
  //               position: 'relative',
  //               height: 500
  //             }}>
  //             <ScrollSyncPane>
  //               <Scrollbars autoHide>
  //                 <Table stickyHeader>
  //                   <TableHead>
  //                     <TableRow>
  //                       {/* มุมมอง */}
  //                       <TableCell
  //                         style={{ width: '100px', minWidth: '100px', maxWidth: '100px' }}
  //                         align='center'>
  //                         {this.props.translate('perspective')}
  //                       </TableCell>
  //                       {/* ตัวชี้วัด */}
  //                       <TableCell
  //                         style={{
  //                           width: '10rem',
  //                           minWidth: '175px'
  //                         }}
  //                         align='center'>
  //                         {this.props.translate('kpi')}
  //                       </TableCell>
  //                       {/* หน่วยวัด */}
  //                       <TableCell style={{ width: '55px', minWidth: '55px', maxWidth: '55px' }}>
  //                         {this.props.translate('uom')}
  //                       </TableCell>
  //                       {/* ชื่อหน่วยงาน หรือ ชื่อพนักงาน */}
  //                       <TableCell
  //                         style={{
  //                           width: '250px',
  //                           minWidth: '250px',
  //                           maxWidth: '250px'
  //                         }}
  //                         colSpan={2}
  //                         align='center'>
  //                         {data1 ? data1[0]?.org_name || data1[0]?.emp_name || '' : ''}
  //                       </TableCell>
  //                     </TableRow>
  //                   </TableHead>
  //                   <TableBody>
  //                     {data1
  //                       ? data1.map((row, index) => (
  //                           <Aux key={index}>
  //                             <TableRow>
  //                               <TableCell rowSpan={3}>
  //                                 {row !== null ? row.perspective_name : <br />}
  //                               </TableCell>
  //                               <TableCell rowSpan={3}>
  //                                 <p>{row.item_name}</p>
  //                                 <p style={{ color: 'blue' }}>{row.date}</p>
  //                               </TableCell>
  //                               <TableCell rowSpan={3} align='center'>
  //                                 {row !== null ? row.uom_name : <br />}
  //                               </TableCell>
  //                               {/* เป้า */}
  //                               <TableCell align='right'>
  //                                 {this.props.translate('targetValue')}
  //                               </TableCell>
  //                               {/* ผลงาน */}
  //                               <TableCell align='right'>
  //                                 {this.props.translate('actualValue')}
  //                               </TableCell>
  //                             </TableRow>
  //                             <TableRow>
  //                               <TableCell align='right'>
  //                                 {row !== null ? (
  //                                   parseFloat(row.target_value)
  //                                     .toFixed(2)
  //                                     .replace(/\d(?=(\d{3})+\.)/g, '$&,')
  //                                 ) : (
  //                                   <br />
  //                                 )}
  //                               </TableCell>
  //                               <TableCell align='right'>
  //                                 {row !== null ? (
  //                                   parseFloat(row.actual_value)
  //                                     .toFixed(2)
  //                                     .replace(/\d(?=(\d{3})+\.)/g, '$&,')
  //                                 ) : (
  //                                   <br />
  //                                 )}
  //                               </TableCell>
  //                             </TableRow>
  //                             <TableRow>
  //                               {/* % เป้าหมาย */}
  //                               <TableCell align='right' style={{ width: '20%', minWidth: '130px' }}>
  //                                 %{this.props.translate('achievement')} &nbsp;
  //                                 {row !== null ? (
  //                                   row.percent_achievement ? (
  //                                     parseFloat(row.percent_achievement).toFixed(2)
  //                                   ) : (
  //                                     ' '
  //                                   )
  //                                 ) : (
  //                                   <br />
  //                                 )}
  //                               </TableCell>
  //                               <TableCell style={{ width: '20%', minWidth: '250px' }} align='left'>
  //                                 <div style={{ height: '40px' }}>
  //                                   <ResponsiveBullet
  //                                     data={[
  //                                       {
  //                                         ranges: ranges,
  //                                         measures: [+row?.percent_achievement],
  //                                         markers: [100]
  //                                       }
  //                                     ]}
  //                                     margin={{ top: 5, right: 10, bottom: 25, left: 5 }}
  //                                     spacing={10}
  //                                     titleAlign='start'
  //                                     titleOffsetX={-55}
  //                                     measureSize={0.25}
  //                                     markerSize={1}
  //                                     animate={true}
  //                                     motionStiffness={20}
  //                                     motionDamping={12}
  //                                     measureColors={'black'}
  //                                     markerColors={'white'}
  //                                     rangeColors={colors}
  //                                   />
  //                                 </div>
  //                               </TableCell>
  //                             </TableRow>
  //                           </Aux>
  //                         ))
  //                       : ''}
  //                   </TableBody>
  //                 </Table>
  //               </Scrollbars>
  //             </ScrollSyncPane>

  //             <ScrollSyncPane>
  //               <Scrollbars autoHide style={{ display: 'inline-block' }}>
  //                 <Table stickyHeader>
  //                   <TableHead>
  //                     <TableRow>
  //                       {Object.values(label_list).map((labelList, index) => (
  //                         <Aux>
  //                           {index !== 0 ? (
  //                             <Aux key={index}>
  //                               <TableCell
  //                                 style={{
  //                                   width: '250px',
  //                                   minWidth: '250px',
  //                                   maxWidth: '250px'
  //                                 }}
  //                                 colSpan={2}
  //                                 align='center'>
  //                                 {label_list !== null ? (
  //                                   labelList.org_name || labelList.full_name
  //                                 ) : (
  //                                   <br />
  //                                 )}
  //                               </TableCell>
  //                             </Aux>
  //                           ) : (
  //                             ''
  //                           )}
  //                         </Aux>
  //                       ))}
  //                     </TableRow>
  //                   </TableHead>
  //                   <TableBody>
  //                     {data2.map(row => (
  //                       <Aux>
  //                         <TableRow>
  //                           {row !== null
  //                             ? Object.values(row).map((data, index) => (
  //                                 <Aux>
  //                                   {index !== 0 ? (
  //                                     <Aux key={index}>
  //                                       <TableCell align='right'>
  //                                         {this.props.translate('targetValue')}
  //                                       </TableCell>
  //                                       <TableCell align='right'>
  //                                         {this.props.translate('actualValue')}
  //                                       </TableCell>
  //                                     </Aux>
  //                                   ) : (
  //                                     ''
  //                                   )}
  //                                 </Aux>
  //                               ))
  //                             : ''}
  //                         </TableRow>
  //                         <TableRow>
  //                           {row !== null
  //                             ? Object.values(row).map((data, index) => (
  //                                 <Aux>
  //                                   {index !== 0 ? (
  //                                     <Aux key={index}>
  //                                       <TableCell
  //                                         align='right'
  //                                         style={{
  //                                           width: '137px',
  //                                           maxWidth: '137px',
  //                                           minWidth: '137px'
  //                                         }}>
  //                                         {data !== null ? (
  //                                           parseFloat(data.target_value)
  //                                             .toFixed(2)
  //                                             .replace(/\d(?=(\d{3})+\.)/g, '$&,')
  //                                         ) : (
  //                                           <br />
  //                                         )}
  //                                       </TableCell>
  //                                       <TableCell align='right'>
  //                                         {data !== null ? (
  //                                           parseFloat(data.actual_value)
  //                                             .toFixed(2)
  //                                             .replace(/\d(?=(\d{3})+\.)/g, '$&,')
  //                                         ) : (
  //                                           <br />
  //                                         )}
  //                                       </TableCell>
  //                                     </Aux>
  //                                   ) : (
  //                                     ''
  //                                   )}
  //                                 </Aux>
  //                               ))
  //                             : ''}
  //                         </TableRow>
  //                         <TableRow>
  //                           {row !== null
  //                             ? Object.values(row).map((data, index) => (
  //                                 <Aux>
  //                                   {index !== 0 ? (
  //                                     <Aux key={index}>
  //                                       <TableCell
  //                                         align='right'
  //                                         style={{ width: '20%', minWidth: '130px' }}>
  //                                         %{this.props.translate('achievement')} &nbsp;
  //                                         {data !== null ? (
  //                                           data.percent_achievement ? (
  //                                             parseFloat(data.percent_achievement).toFixed(2)
  //                                           ) : (
  //                                             ' '
  //                                           )
  //                                         ) : (
  //                                           <br />
  //                                         )}
  //                                       </TableCell>
  //                                       <TableCell
  //                                         style={{ width: '20%', minWidth: '250px' }}
  //                                         align='left'>
  //                                         <div style={{ height: '40px' }}>
  //                                           <ResponsiveBullet
  //                                             data={[
  //                                               {
  //                                                 ranges: ranges,
  //                                                 measures: [
  //                                                   +data?.percent_achievement
  //                                                     ? +data?.percent_achievement
  //                                                     : 0
  //                                                 ],
  //                                                 markers: [100]
  //                                               }
  //                                             ]}
  //                                             margin={{ top: 5, right: 10, bottom: 25, left: 5 }}
  //                                             spacing={10}
  //                                             titleAlign='start'
  //                                             titleOffsetX={-55}
  //                                             measureSize={0.25}
  //                                             markerSize={1}
  //                                             animate={true}
  //                                             motionStiffness={20}
  //                                             motionDamping={12}
  //                                             measureColors={'black'}
  //                                             markerColors={'white'}
  //                                             rangeColors={colors}
  //                                           />
  //                                         </div>
  //                                       </TableCell>
  //                                     </Aux>
  //                                   ) : (
  //                                     ''
  //                                   )}
  //                                 </Aux>
  //                               ))
  //                             : ''}
  //                         </TableRow>
  //                       </Aux>
  //                     ))}
  //                   </TableBody>
  //                 </Table>
  //               </Scrollbars>
  //             </ScrollSyncPane>
  //           </TableContainer>
  //         </ScrollSync>
  //       </Paper>
  //     )
  //   }
  render() {
    console.log(this.props)
    let header = [
      {
        name: this.props.translate('perspective'),
        key: 'perspective_name',
        width: 100,
        style: { position: 'sticky', top: 0, left: 0, zIndex: 100 }
      },
      {
        name: this.props.translate('kpi'),
        key: 'item_name',
        width: 150,
        style: { position: 'sticky', top: 0, left: 132, zIndex: 100 }
      },
      {
        name: this.props.translate('uom'),
        key: 'uom_name',
        width: 50,
        style: { position: 'sticky', top: 0, left: 314, zIndex: 100 }
      }
    ]
    if (this.props.allData?.label_list.length > 0) {
      this.props.allData.label_list.map((list, i) => {
        let left = {}
        if (i === 0) {
          left = { left: 392, zIndex: 100 }
        }
        header.push({
          name: list?.full_name || list?.org_name,
          key: list.emp__id,
          width: 240,
          style: { position: 'sticky', top: 0, zIndex: 50, ...left }
        })
        return list
      })
    }
    // header.push({
    //   key: '28',
    //   name: 'จินตนา หาญมงคล',
    //   width: 220,
    //   style: { position: 'sticky', top: 0, zIndex: 10 }
    // })
    let rows = this.props.allData.table
    let ranges = []
    let rangeColors = []
    if (this.props.allData.table.length > 0) {
      this.props.allData.table[0][0].threshold.map(item => {
        ranges.push(+item.end_value)
        rangeColors.push(item.color_code)
        return item
      })
    }
    const StyledTableCellHead = withStyles(theme => ({
      head: {
        backgroundColor: '#f1f1f1'
      }
    }))(TableCell)
    const StyledTableCell = withStyles(theme => ({
      head: {
        backgroundColor: 'white',
        zIndex: 50
      },
      body: {
        backgroundColor: 'white',
        zIndex: 50
      }
    }))(TableCell)
    const StyledTableCelll = withStyles(theme => ({
      head: {
        zIndex: 10
      },
      body: {
        zIndex: 10
      }
    }))(TableCell)
    return (
      <Aux>
        <Grid container>
          <Grid item>
            <Table>
              <TableHead>
                <TableRow>
                  {header.map(item => (
                    <StyledTableCellHead style={{ minWidth: item.width, ...item.style }}>
                      {item.name}
                    </StyledTableCellHead>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, i) => (
                  <TableRow key={row.i}>
                    <StyledTableCell align='right' style={{ position: 'sticky', left: 0 }}>
                      {row[0].perspective_name}
                    </StyledTableCell>
                    <StyledTableCell align='right' style={{ position: 'sticky', left: 132 }}>
                      <p>{row[0].item_name}</p>
                      <p style={{ color: 'blue' }}>{row[0].date}</p>
                    </StyledTableCell>
                    <StyledTableCell align='right' style={{ position: 'sticky', left: 314 }}>
                      {row[0].uom_name}
                    </StyledTableCell>

                    <StyledTableCell align='right' style={{ position: 'sticky', left: 392 }}>
                      <div>
                        <div>
                          {this.props.translate('targetValue')}:{' '}
                          {getCurrencyNumber(row[0].target_value, 2)}
                        </div>
                        <div>
                          {this.props.translate('actualValue')}:{' '}
                          {getCurrencyNumber(row[0].actual_value, 2)}
                        </div>
                        <div>
                          %{this.props.translate('achievement')}:{' '}
                          {getCurrencyNumber(row[0].percent_achievement, 2)}
                        </div>

                        <div style={{ height: '40px' }}>
                          <ResponsiveBullet
                            data={[
                              {
                                ranges: ranges,
                                measures: [
                                  +row[0]?.percent_achievement ? +row[0]?.percent_achievement : 0
                                ],
                                markers: [100]
                              }
                            ]}
                            margin={{ top: 5, right: 10, bottom: 25, left: 5 }}
                            spacing={10}
                            titleAlign='start'
                            titleOffsetX={-55}
                            measureSize={0.25}
                            markerSize={1}
                            animate={true}
                            motionStiffness={20}
                            motionDamping={12}
                            measureColors={'#454545'}
                            markerColors={'white'}
                            rangeColors={rangeColors}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                    {console.log(row, i, 'row')}
                    {row.map((r, n) =>
                      n > 0 ? (
                        <StyledTableCelll align='right' style={{ position: 'sticky', left: 392 }}>
                          <div>
                            <div>
                              {this.props.translate('targetValue')}:{' '}
                              {getCurrencyNumber(r?.target_value, 2)}
                            </div>
                            <div>
                              {this.props.translate('actualValue')}:{' '}
                              {getCurrencyNumber(r?.actual_value, 2)}
                            </div>
                            <div>
                              %{this.props.translate('achievement')}:{' '}
                              {getCurrencyNumber(r?.percent_achievement, 2)}
                            </div>
                            {console.log(r)}
                            <div style={{ height: '40px' }}>
                              <ResponsiveBullet
                                data={[
                                  {
                                    ranges: ranges,
                                    measures: [
                                      +r?.percent_achievement ? +r?.percent_achievement : 0
                                    ],
                                    markers: [100]
                                  }
                                ]}
                                margin={{ top: 5, right: 10, bottom: 25, left: 5 }}
                                spacing={10}
                                titleAlign='start'
                                titleOffsetX={-55}
                                measureSize={0.25}
                                markerSize={1}
                                animate={true}
                                motionStiffness={20}
                                motionDamping={12}
                                measureColors={'#454545'}
                                markerColors={'white'}
                                rangeColors={rangeColors}
                              />
                            </div>
                          </div>
                        </StyledTableCelll>
                      ) : null
                    )}
                    {/* <StyledTableCelll align='right'>
                      <div>
                        <div>Target Value{row[0].target_value}</div>
                        <div>Actual Value{row[0].actual_value}</div>
                        <div style={{ height: '40px' }}>
                          <ResponsiveBullet
                            data={[
                              {
                                ranges: [20, 40, 60, 80, 100],
                                measures: [
                                  +row[0]?.percent_achievement ? +row[0]?.percent_achievement : 0
                                ],
                                markers: [100]
                              }
                            ]}
                            margin={{ top: 5, right: 10, bottom: 25, left: 5 }}
                            spacing={10}
                            titleAlign='start'
                            titleOffsetX={-55}
                            measureSize={0.25}
                            markerSize={1}
                            animate={true}
                            motionStiffness={20}
                            motionDamping={12}
                            measureColors={'black'}
                            markerColors={'white'}
                            rangeColors={['#264653', '#2a9d8f', '#e9c46a', '#f4a261', '#e76f51']}
                          />
                        </div>
                      </div>
                    </StyledTableCelll> */}
                    {/* {row.map(r => return (
                      <TableCell align='right'>
                        <div>
                          <div>Target Value{r.target_value}</div>
                          <div>Actual Value{r.actual_value}</div>
                          <div>{r.uom_name}</div>
                        </div>
                      </TableCell>
                    ))} */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
          {/* <Grid item xs={6}>
            <Table aria-label='simple table'>
              <TableHead>
                <TableRow>
                  {header.map(item => (
                    <TableCell>{item.name}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, i) => (
                  <TableRow key={row.i}>
                    <TableCell component='th' scope='row'>
                      {row[0].perspective_name}
                    </TableCell>
                    <TableCell align='right'>{row[0].item_name}</TableCell>
                    <TableCell align='right'>{row[0].uom_name}</TableCell>
                    <TableCell align='right'>{row[0].uom_name}</TableCell>
                    <TableCell align='right'>{row[0].uom_name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid> */}
        </Grid>
      </Aux>
    )
  }
}

export default withTranslate(Form)
